import { CompactOrgResponse, OrgAddressResponse } from '@business/entities/organization';
import { PageQuery } from '../common';
import { BaseResponse } from './../common/BaseResponse';
import { OrderShipmentId, OrderShipmentStatus } from './OrderShipmentResponse';
import { OrderId, CompactOrderResponse } from './OrderResponse';
import { OrderVendorResponse } from './OrderVendorResponse';
import { TimeMaterialShipmentStatus } from '../tm/TimeMaterialShipmentResponse';
import { POStatusResponse } from '../poStatus';
export type PurchaseOrderId = string;

export enum PurchaseOrderStatus {
  opened = 'opened',
  closed = 'closed',
  invoiced = 'invoiced',
  acknowledged = 'acknowledged',
  shipped = 'shipped',
  delivered = 'delivered',
}

export interface PurchaseOrderResponse extends BaseResponse {
  id: PurchaseOrderId;
  poNumber: string;
  number: string;
  shippedDate: number | null;
  importId: string;
  orderId: OrderId;
  poId: string;
  title: string;
  status: PurchaseOrderStatus | OrderShipmentStatus | TimeMaterialShipmentStatus;
  totalAmount: number;
  amount: number;
  billEmail: string;
  organization: CompactOrgResponse;
  vendor: OrderVendorResponse;
  memo: string;
  message: string;
  isSoft: boolean;
  isSent: boolean;
  items: PurchaseOrderLineItem[];
  shippingMethod: string;
  billOfLading: POBillOfLadingResponse;
  pickList: POBillOfLadingResponse;
  billingAddress: OrgAddressResponse;
  shippingAddress: OrgAddressResponse;
  poStatus?: POStatusResponse;
  type: PoType;
}

export interface PurchaseOrderLineItem {
  id: number;
  productId: string;
  serviceId: string;
  classId: string;
  productTitle: string;
  productSku: string;
  quantity: number;
  unitPrice: number;
  price: number;
  description: string;
  shipmentId: OrderShipmentId;
  status: OrderShipmentStatus;
  shippedDate?: number;
  deliveryDate?: number;
  thumbnail: string;
  unitOfMeasure: string;
  vendorId: string;
  shippingMethod: string;
  lineId: string;
}

export interface CompactPurchaseOrderResponse extends BaseResponse {
  id: PurchaseOrderId;
  poNumber: string;
  number: string;
  orderId: OrderId;
  poId: string;
  title: string;
  status: PurchaseOrderStatus;
  totalAmount: number;
  amount: number;
  vendor: OrderVendorResponse;
  order: CompactOrderResponse;
  memo: string;
  message: string;
  isSoft: boolean;
  isSent: boolean;
  items: PurchaseOrderLineItem[];
  billingAddress: OrgAddressResponse;
  shippingAddress: OrgAddressResponse;
  currency: string;
  poStatus?: POStatusResponse;
  type: PoType;
}

export enum PoType {
  order = 'order',
  timeMaterial = 'timeMaterial',
}

export interface PurchaseOrderPageQuery extends PageQuery {
  status?: string;
  search?: string;
}

export enum POLadingStatus {
  save = 'save',
  print = 'print',
}

export interface POBillOfLadingResponse {
  freightTerms: string;
  fob: string;
  customerPO: string;
  notes: string;
  status: POLadingStatus;
  shippingMethod: string;
  shippedDate: number | null;
  date: number | null;
  items: POLadingLine[];
}

export interface POLadingLine {
  id: number;
  productTitle: string;
  quantity: number;
  description: string;
  unitOfMeasure: string;
  product: string;
  productId: string;
  serviceId: string;
}
